// AssetDataMap.jsx

import React, { useEffect, useRef, useState } from 'react';
import { loadModules } from 'esri-loader';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Select,
  MenuItem,
  Button,Box
} from '@mui/material';
import MasterAddEditData from "./MasterAddEditAssetData"
import {getAllMyAssets,getAssetBuilder,simulateAsset,UpdateSimulateAsset} from "../../REST/assets"
import {GetMapLayers, AddUpdateMapLayer} from '../../REST/maplayer';
import { createCombinedControlForEsriLoader } from '../../Components/Gis';
import Access from '../../Utils/authorize';
const AssetDataMap = () => {
  // Reference to the map DOM element
  const mapRef = useRef(null);
  const assetTypeContainerRef = useRef(null)
  // State variables
  const [dataloaded,setDateloaded] = useState(false)
  const [assets,setAssets] = useState(null)
  const [assetTypes,setAssetTypes]  = useState(null)
  const [view, setView] = useState(null);
  const [graphicsLayer, setGraphicsLayer] = useState(null);
  const [mapConstruct,setMapConstruct] = useState(null)
  const [selectedAssetType, setSelectedAssetType] = useState('');
  const [openDialog, setOpenDialog] = useState(false);
  const [newAsset, setNewAsset] = useState({
    assetType: '',
    name: '',
    assetnumber: '',
    status: true,
    location: {lon:-119.734,lat: 39.193},
  });
  const [refresh,setRefresh] = useState(true)
  
  useEffect(()=>{
    Promise.all([getAllMyAssets(),getAssetBuilder()])
    .then((values)=>{
        setAssets(values[0].data)
        setAssetTypes(values[1].data)
        setDateloaded(true)
    })
  },[refresh])
useEffect(() => {
  if (!dataloaded) return;

  let cancelled = false;
  let mapView = null;

  const initMap = async () => {
    try {
      const [
        Map,
        MapView,
        GraphicsLayer,
        Search,
        BasemapToggle,
        Graphic,
        Point,
        SimpleMarkerSymbol,
        Color
      ] = await loadModules(
        [
          'esri/Map',
          'esri/views/MapView',
          'esri/layers/GraphicsLayer',
          'esri/widgets/Search',
          'esri/widgets/BasemapToggle',
          'esri/Graphic',
          'esri/geometry/Point',
          'esri/symbols/SimpleMarkerSymbol',
          'esri/Color'
        ],
        { css: true }
      );

      if (cancelled || !mapRef.current) return;

      const map = new Map({
        basemap: 'streets-navigation-vector',
      });

      mapView = new MapView({
        container: mapRef.current,
        map,
        center: [0, 0],
        zoom: 2,
      });

      const layer = new GraphicsLayer();
      map.add(layer);

      const searchWidget = new Search({
        view: mapView,
      });

      mapView.ui.add(searchWidget, {
        position: 'bottom-right',
      });

      const basemapToggle = new BasemapToggle({
        view: mapView,
        nextBasemap: 'satellite',
      });

      mapView.ui.add(basemapToggle, {
        position: 'bottom-left',
      });

      mapView.ui.remove('zoom');

      await mapView.when();

      if (cancelled || mapView.destroyed) return;

      await createCombinedControlForEsriLoader({
        view: mapView,
        canEditConfig:  Access.isAdmin('Settings'),
        collapsedByDefault: false,
        loadConfig: async () => {
          const raw = await GetMapLayers();
          return raw ? raw.data : [];
        },
        saveConfig: async (configs) => {
          const result = await AddUpdateMapLayer(configs);
          return result.data;
        },
        defaultLayerConfigs: [],
      });

      if (cancelled || mapView.destroyed) return;

      if (assetTypeContainerRef.current) {
        mapView.ui.add(assetTypeContainerRef.current, 'top-right');
      }

      const hitTestOptions = {
        include: layer,
      };

      const clickHandle = mapView.on('click', (event) => {
        mapView.hitTest(event, hitTestOptions).then((response) => {
          if (mapView.destroyed) return;

          if (response.results.length === 0) {
            if (assetTypes.length === 0) return;

            const { latitude, longitude } = event.mapPoint;

            setNewAsset((prev) => ({
              ...prev,
              location: {
                lat: latitude,
                lon: longitude,
              },
            }));

            setOpenDialog(true);
          }
        });
      });

      if (cancelled || mapView.destroyed) {
        clickHandle.remove();
        return;
      }

      setView(mapView);
      setGraphicsLayer(layer);
      setMapConstruct({
        Graphic,
        SimpleMarkerSymbol,
        Color,
        Point,
      });
    } catch (err) {
      if (!cancelled) {
        console.error(err);
      }
    }
  };

  initMap();

  return () => {
    cancelled = true;

    if (mapView && !mapView.destroyed) {
      mapView.destroy();
    }
  };
}, [dataloaded]);

  useEffect(() => {
    if (graphicsLayer  && dataloaded && mapConstruct) {
      // Clear existing graphics
      graphicsLayer.removeAll();
      
      // Filter assets based on selectedAssetType
      const filteredAssets = selectedAssetType
        ? assets.filter((asset) => asset.assetId === selectedAssetType)
        : assets;
       const graphicsArray = [] 
      // Add graphics to the layer
      filteredAssets.forEach((asset) => {
        // Create point geometry
        const type = assetTypes.find((t)=>{ return t._id == asset.assetId})
        const colorhex = type.color
        const point = {
          type: 'point',
          longitude: asset.location.lon,
          latitude: asset.location.lat,
        };

        // Define symbol with color from assetId.color
        const symbol = {
          type: 'simple-marker',
          color: new mapConstruct.Color(colorhex),
          outline: {
            color: [255, 255, 255], 
            width: 1,
          },
        };

        // Set attributes for the popup template
        const attributes = {
          name: asset.name,
          assetnumber: asset.assetnumber,
          dateadded: asset.createdAt ? new Date(asset.createdAt).toLocaleString() : "N/A",
          id: asset._id,
          assettype:type.name 
        };
        
        // Define the popup template
        const popupTemplate = {
          title: '{name}',
          content:  `
          <b>Asset Type:</b> {assettype}<br/>
          <b>Asset Number:</b> {assetnumber}<br/>
          <b>Date Added:</b> {dateadded}<br/>
          <a href="#details?id={id}" class="popup-details-link">View Details</a>
        `,
        };
         
        // Create the graphic
        const graphic = new mapConstruct.Graphic({
          geometry: point,
          symbol: symbol,
          attributes: attributes,
          popupTemplate: popupTemplate,
        });

        // Add graphic to the layer
        graphicsArray.push(graphic);
      });

      graphicsLayer.addMany(graphicsArray);

      // Zoom to the extent of the graphics
      if (graphicsArray.length > 0) {
        // Use the graphicsLayer's full extent
        view.goTo({center:graphicsArray[0].geometry,zoom:13}); // Expand the extent by 50% for padding
      }
    }
  }, [graphicsLayer, dataloaded, selectedAssetType,mapConstruct]);
  useEffect(() => {
    if (view) {
      const handlePopupClick = (event) => {
        
       
        
        const target = event.target;
  
        if (target.classList.contains('popup-details-link')) {

          event.preventDefault(); // Prevent default link behavior
          const href = target.getAttribute('href'); // Get href
          const params = new URLSearchParams(href.split('?')[1]); // Extract query params
          const assetId = params.get('id'); // Get the id parameter
          const asset = assets.find((a) => a._id === assetId); // Find the asset data
  
          if (asset) {
            setNewAsset({
              id:asset._id,
              _id:asset._id,
              assetType: asset.assetId,
              name: asset.name,
              assetnumber: asset.assetnumber,
              status: true, // Set this based on your logic
              location: asset.location,
            });
  
            setOpenDialog(true); // Open the dialog
          }
        }
      };
      
      // Attach event listener
      const popupContainer = view.popup.container;

      if (popupContainer) {
        popupContainer.addEventListener('click', handlePopupClick);
      }
  
      // Cleanup listener on component unmount
      return () => {
        if (view && popupContainer) {
          popupContainer.removeEventListener('click', handlePopupClick);
        }
      };
    }
  }, [view, assets]);

  // Handle dialog close
  const handleDialogClose = (saved) => {
    
    
    if(saved) {
      setDateloaded(false)
      setNewAsset(saved.data)
      setRefresh(!refresh)
      
    }
    else
    {
      setNewAsset({
        assetType: '',
        name: '',
        assetnumber: '',
        status: '',
        location: {lon:-119.734,lat: 39.193},
      });
      setOpenDialog(false);
    }
  };


  if (!dataloaded || !assetTypes) {
    return null; // Let the global loader handle loading state
  }

  return (
    <div style={{ height: '100%', width: '100%' }}>
        
      <div style={{ height: '100%', width: '100%' }} ref={mapRef}></div>

      {/* Asset Type Selector */}
      <div
        ref={assetTypeContainerRef}
        className="esri-component esri-widget"
        style={{ padding: '10px' }}
      >
        <Select
          value={selectedAssetType}
          onChange={(e) => setSelectedAssetType(e.target.value)}
          displayEmpty
        >
          <MenuItem value="">
            <span>All Asset Types</span>
          </MenuItem>
          {assetTypes.map((assetType) => (
            <MenuItem key={assetType._id} value={assetType._id}>
              {assetType.name}
            </MenuItem>
          ))}
        </Select>
      </div>
      {openDialog && (<MasterAddEditData  assetId={selectedAssetType} 
           handleClose={handleDialogClose} assetTypes={assetTypes} location={newAsset.location}  id={newAsset._id} />) }    
       
    </div>
  );
};

export default AssetDataMap;
